<template>
  <v-dialog
    v-model="dialogFlag"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    scrollable
  >
    <v-container fluid primary>
      <v-dialog persistent v-model="editSettingDialogFlag" width="500">
        <v-card>
          <v-card-title class="headline grey lighten-2" primary-title>{{$t("dlgEditSettingsTitle")}}</v-card-title>

          <v-card-text>
            <v-container>
              <v-form ref="editSettingForm" lazy-validation>
                <v-row>
                  <!-- Periodo de tiempo mínimo para reservar una sala -->
                  <v-col cols="12" sm="6">
                    <v-menu :close-on-content-click="true">
                      <template v-slot:activator="{ on: menuTimeSlice }">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on: tooltipTimeSlice }">
                            <v-btn
                              color="primary"
                              dark
                              v-on="{ ...tooltipTimeSlice, ...menuTimeSlice }"
                              v-html="$t('minutesTitle', { minutes: currentSetting.minutes  })"
                            ></v-btn>
                          </template>
                          <span>
                            <p v-html="$t('lblMinutes')" />
                          </span>
                        </v-tooltip>
                      </template>
                      <v-list>
                        <v-list-item
                          v-for="(item, index) in minutesItems"
                          :key="index"
                          @click="selectMinutes(item)"
                        >
                          <v-list-item-title v-html="$t('minutesTitle', item)"></v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>

                    <p v-html="$t('lblMinutesInfo')" class="mt-4" />
                  </v-col>

                  <!-- 
                    Junta recurrente  
                  -->
                  <v-col cols="12" sm="6">
                    <v-menu :close-on-content-click="true">
                      <template v-slot:activator="{ on: menuRecurrency }">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on: tooltipRecurrency }">
                            <v-btn
                              color="primary"
                              dark
                              v-on="{ ...tooltipRecurrency, ...menuRecurrency }"
                              v-html="$t('maxRecurrencyTitle', { month: (currentSetting.maxRecurrency / 4) })"
                            ></v-btn>
                          </template>
                          <p v-html="$t('lblMaxRecurrency')" />
                        </v-tooltip>
                      </template>
                      <v-list>
                        <v-list-item
                          v-for="(item, index) in maxRecurrencyItems"
                          :key="index"
                          @click="selectMaxRecurrency(item)"
                        >
                          <v-list-item-title v-html="$t('maxRecurrencyTitle', item)"></v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                    <p v-html="$t('lblMaxRecurrencyInfo')" class="mt-4" />
                  </v-col>

                  <!-- 
                    CHECKIN antes de iniciar una junta
                  -->
                  <v-col cols="12" sm="6">
                    <v-menu :close-on-content-click="true">
                      <template v-slot:activator="{ on: menuCheckinBefore }">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on: tooltipCheckinBefore }">
                            <v-btn
                              color="primary"
                              dark
                              v-on="{ ...tooltipCheckinBefore, ...menuCheckinBefore }"
                              v-html="$t('checkinBeforeTitle', { minutes: currentSetting.checkInBefore })"
                            ></v-btn>
                          </template>
                          <p v-html="$t('lblCheckinBefore')" />
                        </v-tooltip>
                      </template>
                      <v-list>
                        <v-list-item
                          v-for="(item, index) in checkinBeforeItems"
                          :key="index"
                          @click="selectCheckinBefore(item)"
                        >
                          <v-list-item-title v-html="$t('checkinBeforeTitle', item)"></v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>

                    <p v-html="$t('lblCheckinBeforeInfo')" class="mt-4" />
                  </v-col>
                  <!-- CHECKIN después de iniciar una junta -->
                  <v-col cols="12" sm="6">
                    <v-menu :close-on-content-click="true">
                      <template v-slot:activator="{ on: menuCheckinAfter }">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on: tooltipCheckinAfter }">
                            <v-btn
                              color="primary"
                              dark
                              v-on="{ ...tooltipCheckinAfter, ...menuCheckinAfter }"
                              v-html="$t('checkinAfterTitle', { minutes: currentSetting.checkInAfter })"
                            ></v-btn>
                          </template>
                          <p v-html="$t('lblCheckinAfter')" />
                        </v-tooltip>
                      </template>
                      <v-list>
                        <v-list-item
                          v-for="(item, index) in checkinBeforeItems"
                          :key="index"
                          @click="selectCheckinAfter(item)"
                        >
                          <v-list-item-title v-html="$t('checkinAfterTitle', item)"></v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>

                    <p v-html="$t('lblCheckinAfterInfo')" class="mt-4" />
                  </v-col>
                  <v-col cols="12" v-if="errorMessage != ''">
                    <p class="caption error--text" v-html="errorMessage"></p>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click.stop="closeEditSettingDialog()">{{$t("btnCancel")}}</v-btn>
            <v-btn text @click.stop="doUpdateSettingDialog()" color="primary">{{$t("btnSave")}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-card>
        <v-toolbar dark color="secondary">
          <v-toolbar-title>{{$t('moduleTitle', { locationName: location.name })}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click.stop="closeDialog()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-data-table
          :loading="isLoading"
          :headers="headers"
          :items="settings"
          class="elevation-1 mt-10"
          color="primary"
        >
          <template v-slot:top></template>

          <!-- PANEL DE ACCIONES -->
          <template v-slot:item.action="{ item }">
            <v-btn @click.stop="showEditSettingDialog(item)" icon class="ml-2" tile>
              <v-icon fab>mdi mdi-pencil</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
  </v-dialog>
</template>

<script>
import i18nMessages from "./i18n.messages";
import { mapGetters } from "vuex";
import _ from "lodash";

export default {
  props: {
    settings: {
      type: Array,
      required: true
    },

    locationId: {
      type: Number,
      required: true
    },

    location: {
      type: Object,
      required: true
    },

    dialogFlag: {
      type: Boolean,
      required: true
    }
  },
  created() {
    this.$i18n.locale = this.locale;
    this.updateHeadersLocale();
  },
  beforeDestroy() {},
  i18n: i18nMessages,
  data: function() {
    return {
      reloadLocations: false,
      sourceSetting: {},
      //
      // toggle_minutes: undefined,
      //
      errorMessage: "",
      //
      editSettingDialogFlag: false,
      //
      currentSetting: {},
      //Encabezados de la tabla
      //La propiedad "id" corresponde al identificador de la etiqueta
      //en el archivo de mensajes que se utilizar para los idiomas
      headers: [
        {
          id: "headerItemType",
          text: "Tipo de configuración",
          sortable: false,
          value: "name"
        },
        {
          id: "headerDescription",
          text: "Descripción",
          value: "comments",
          sortable: false
        },
        {
          id: "headerSlotTime",
          text: "Reserva mínima (en min)",
          value: "minutes",
          sortable: false
        },
        {
          id: "headerMaxTime",
          text: "Máxima recurrencia (en semanas)",
          value: "maxRecurrency",
          sortable: false
        },
        {
          id: "headerCheckInBefore",
          text: "Minutos para confirmar (antes)",
          value: "checkInBefore",
          sortable: false
        },
        {
          id: "headerCheckInAfter",
          text: "Minutos para confirmar (después)",
          value: "checkInAfter",
          sortable: false
        },
        {
          id: "headerAction",
          text: "Acciones",
          value: "action",
          sortable: false
        }
      ],

      //
      minutesItems: [{ minutes: 30 }, { minutes: 60 }, { minutes: 120 }],
      //
      maxRecurrencyItems: [
        { month: 1 },
        { month: 2 },
        { month: 3 },
        { month: 4 },
        { month: 5 },
        { month: 6 }
      ],
      //
      checkinBeforeItems: [
        { minutes: 5 },
        { minutes: 10 },
        { minutes: 15 },
        { minutes: 30 }
      ],
      //
      checkinAfterItems: [
        { minutes: 5 },
        { minutes: 10 },
        { minutes: 15 },
        { minutes: 20 },
        { minutes: 25 },
        { minutes: 30 }
      ]
    };
  },
  mounted: () => {},
  computed: {
    ...mapGetters(["isLoading"]),
    locale() {
      return this.$store.getters["locale"];
    }
  },
  watch: {
    locale(value) {
      this.$i18n.locale = value;
      this.updateHeadersLocale();
    }
  },
  methods: {
    // Actualiza el idioma de los encabezados de la tabla
    updateHeadersLocale() {
      this.headers = this.headers.map(header => {
        header.text = this.$t(header.id);
        return header;
      });
    },
    closeDialog() {
      // if (this.reloadLocations) {
      //   this.$emit("reloadLocationsEvent");
      // }
      this.$emit("closeSettingsDialogEvent");
      this.errorMessage = "";
    },

    showEditSettingDialog(setting) {
      this.sourceSetting = setting;
      this.currentSetting = _.clone(setting);
      this.editSettingDialogFlag = true;
    },
    closeEditSettingDialog() {
      this.sourceSetting = {};
      this.currentSetting = {};
      this.editSettingDialogFlag = false;
      this.errorMessage = "";
    },
    doUpdateSettingDialog() {
      //** console.log(this.currentSetting);
      let payload = {
        params: {
          settingId: this.currentSetting.id,
          locationId: this.locationId
        },
        data: this.currentSetting
      };

      this.$PUT("/api/locations/{{locationId}}/settings/{{settingId}}", payload)
        .then(() => {
          //** console.log(response);
          //this.reloadLocations = true;
          this.$emit("reloadLocationsEvent");
          this.closeEditSettingDialog()
        })
        .catch(() => {
          // En caso de error presentar un mensaje
          // al usuario
          this.errorMessage = "Ocurrió un error al ACTUALIZAR la configuración";
        })
        .finally(() => {});

    },
    selectMinutes(item) {
      this.currentSetting.minutes = item.minutes;
    },
    selectMaxRecurrency(item) {
      // Item representa el número de meses
      // y debemos convertirlo a semanas
      // item.month * 4 (semanas)
      this.currentSetting.maxRecurrency = item.month ;
    },
    selectCheckinBefore(item) {
      this.currentSetting.checkInBefore = item.minutes;
    },
    selectCheckinAfter(item) {
      this.currentSetting.checkInAfter = item.minutes;
    }
  }
};
</script>